


























import { ValidationProvider } from 'vee-validate'
import Vue from 'vue'
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'

import { SelectOption } from "../../logic/types";
import Chips from '../Chips/Chips.vue'
import { ChipsInputTabs, ChipsWithSelectData } from "../Pi/fields/ChipsInput/types";
import ToggleButton from "../ToggleButton.vue";
import { BlackWhiteListItem, BlackWhiteListItemType } from './types'

@Component({
  components: {
    ToggleButton,
    Chips,
    ValidationProvider
  }
})
export default class BlackWhiteList extends Vue {
  @VModel({ type: Object }) list!: BlackWhiteListItem<string>

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ default: false }) draggable!: boolean

  @Prop() options!: Array<SelectOption | string>

  @Prop() validation!: string

  @Prop() availableTabs!: Array<ChipsInputTabs>

  @Prop() formatter!: ChipsWithSelectData['formatter']

  @Prop() checkedTitle!: string

  @Prop() uncheckedTitle!: string

  get checked() {
    if (this.checkedTitle) {
      return this.checkedTitle
    }

    return this.$t('black_white_list_radio_whitelist').toString()
  }

  get unchecked() {
    if (this.uncheckedTitle) {
      return this.uncheckedTitle
    }

    return this.$t('black_white_list_radio_blacklist').toString()
  }

  @Emit()
  onUpdate<T extends keyof BlackWhiteListItem<string>>(field: T, value: BlackWhiteListItem<string>[T]) {
    return {
      field,
      value
    }
  }

  get listType(): boolean {
    return this.list.type === BlackWhiteListItemType.Whitelist
  }

  set listType(switchState: boolean) {
    this.onUpdate('type', switchState ? BlackWhiteListItemType.Whitelist : BlackWhiteListItemType.Blacklist)
  }

  isActive(type: BlackWhiteListItemType) {
    if (this.list.type === type) {
      return 'rgba(var(--a-primary), 1)'
    } else {
      return ''
    }
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      black_white_list_radio_whitelist: 'Белый список',
      black_white_list_radio_blacklist: 'Черный список',
    })

    this.$i18n.mergeLocaleMessage('en', {
      black_white_list_radio_whitelist: 'White list',
      black_white_list_radio_blacklist: 'Black list',
    })
  }
}
